/* eslint-disable no-shadow */
import { IB2BAddress } from '../b2b/addresses';
import { IB2CAddressWithMetaData } from '../b2c/addresses';
import { TZipCodeFormValues } from './zipcode';

export type TAddressFormValues = Pick<
  IMappedAddress,
  | 'isDefault'
  | 'companyName'
  | 'firstName'
  | 'lastName'
  | 'nickName'
  | 'primaryPhone'
  | 'alternatePhone'
  | 'addressLine1'
  | 'addressLine2'
> &
  TZipCodeFormValues;

export type IMappedAddress = {
  isDefault: boolean;
  companyName: string | undefined;
  firstName: string;
  lastName: string;
  nickName: string | undefined;
  addedBy: string | undefined;
  primaryPhone: string;
  alternatePhone: string | undefined;
  addressLine1: string;
  addressLine2: string | undefined;
  state: string;
  zipCode: string;
  city: string;
  userId: string | undefined;
  lastModifiedDate: number | undefined;
  addrIdentifier: number;
  instantCheckoutDefault: boolean | undefined;
};

export interface IPaginationInfo {
  pageNumber: string;
  pageSize: string;
  totalNumberOfRecords: string;
  totalPages: string;
}

export type TCommonPartialAddress = Partial<IB2BAddress> &
  Partial<IB2CAddressWithMetaData>;

export type IAddressesCommonData = {
  addresses: IMappedAddress[];
  paginationInfo?: Partial<IPaginationInfo> & {
    addressesOnCurrentPage: number;
  };
  response: TCommonPartialAddress[];
};

export type TAddressFormMode = FORM_MODE.ADD | FORM_MODE.EDIT | null;

export enum FORM_MODE {
  EDIT = 'EDIT',
  ADD = 'ADD',
}

export enum COUNTRIES {
  US = 'US',
}

export enum PHONE_TYPES {
  UNKNOWN = 'UNKNOWN',
}

export enum ADDRESS_TYPES {
  SHIPPING = 'SHIPPING',
}

export enum YES_NO_FLAGS {
  YES = 'Y',
  NO = 'N',
}
